import React from 'react';
import { motion } from 'framer-motion';

const CookiePolicyPage = ({ onBack }) => {
  return (
    <div style={{ backgroundColor: '#ffffff', minHeight: '100vh' }}>
      {/* Back Button */}
      <motion.div 
        style={{ 
          padding: '20px',
          position: 'fixed',
          top: '20px',
          left: '20px',
          zIndex: 1000
        }}
        initial={{ opacity: 0, x: -50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.6 }}
      >
        <button 
          onClick={onBack}
          style={{
            background: '#7c3aed',
            color: 'white',
            border: 'none',
            padding: '12px 24px',
            borderRadius: '8px',
            cursor: 'pointer',
            fontSize: '16px',
            fontWeight: '600',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            boxShadow: '0 4px 12px rgba(124, 58, 237, 0.3)',
            transition: 'all 0.3s ease'
          }}
          onMouseOver={(e) => {
            e.target.style.background = '#6d28d9';
            e.target.style.transform = 'translateY(-2px)';
          }}
          onMouseOut={(e) => {
            e.target.style.background = '#7c3aed';
            e.target.style.transform = 'translateY(0px)';
          }}
        >
          ← Back to Home
        </button>
      </motion.div>

      <motion.div 
        className="cookie-policy-page"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        style={{
          padding: '120px 20px 50px 20px',
          maxWidth: '1200px',
          margin: '0 auto',
          lineHeight: '1.6',
          color: '#333',
          backgroundColor: '#ffffff'
        }}
      >
        <motion.h1 
          style={{
            fontSize: '3rem',
            marginBottom: '20px',
            color: '#7c3aed',
            textAlign: 'center'
          }}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          🍪 Cookie Policy
        </motion.h1>
        
        <motion.p 
          style={{
            fontSize: '1.2rem',
            fontWeight: 'bold',
            textAlign: 'center',
            marginBottom: '40px',
            color: '#7c3aed'
          }}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
        >
          Effective Date: 20/12/2024
        </motion.p>
        
        <motion.div 
          style={{
            fontSize: '1.1rem',
            marginBottom: '30px'
          }}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
        >
          <p style={{ marginBottom: '30px' }}>
            LeadVala uses cookies, pixels, and tracking technologies to improve user experience and optimize advertising.
          </p>
        </motion.div>

        <motion.section 
          style={{ marginBottom: '40px' }}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.5 }}
        >
          <h2 style={{ fontSize: '1.8rem', fontWeight: 'bold', marginBottom: '20px', color: '#7c3aed' }}>
            1. What Are Cookies?
          </h2>
          <p style={{ lineHeight: '2' }}>
            Cookies are small text files stored on your device that help websites remember preferences and activity.
          </p>
        </motion.section>

        <motion.section 
          style={{ marginBottom: '40px' }}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
        >
          <h2 style={{ fontSize: '1.8rem', fontWeight: 'bold', marginBottom: '20px', color: '#7c3aed' }}>
            2. Types of Cookies We Use
          </h2>
          <ul style={{ paddingLeft: '20px', lineHeight: '2' }}>
            <li><strong>Essential Cookies</strong>: Required for core website functions.</li>
            <li><strong>Analytics Cookies</strong>: Google Analytics, LinkedIn Insight Tag.</li>
            <li><strong>Advertising Cookies</strong>: Meta Pixel, Google Ads Remarketing, Twitter Ads.</li>
            <li><strong>Performance Cookies</strong>: To measure campaign effectiveness.</li>
          </ul>
        </motion.section>

        <motion.section 
          style={{ marginBottom: '40px' }}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.7 }}
        >
          <h2 style={{ fontSize: '1.8rem', fontWeight: 'bold', marginBottom: '20px', color: '#7c3aed' }}>
            3. How We Use Cookies
          </h2>
          <ul style={{ paddingLeft: '20px', lineHeight: '2' }}>
            <li>Optimize lead forms.</li>
            <li>Track ad conversions.</li>
            <li>Personalize ad delivery.</li>
            <li>Prevent fraud and spam.</li>
          </ul>
        </motion.section>

        <motion.section 
          style={{ marginBottom: '40px' }}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.8 }}
        >
          <h2 style={{ fontSize: '1.8rem', fontWeight: 'bold', marginBottom: '20px', color: '#7c3aed' }}>
            4. Managing Cookies
          </h2>
          <p style={{ marginBottom: '15px' }}>Users can:</p>
          <ul style={{ paddingLeft: '20px', lineHeight: '2' }}>
            <li>Adjust browser settings to block cookies.</li>
            <li>Opt out of Google Ads: Google Ads Settings.</li>
            <li>Opt out of Facebook Ads: Facebook Ad Preferences.</li>
          </ul>
        </motion.section>
      </motion.div>
    </div>
  );
};

export default CookiePolicyPage;